import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import {
  BUSINESS_ROLES_IDENTIFIER,
  ENTITLEMENTS_IDENTIFIER,
  LIST_IDENTIFIER,
  SHOW_TABLE_IDENTIFIER,
  STATE_IDENTIFIER,
} from "./constants";

const {
  STEP_ONE,
  LOADER_IDENTIFIER,
  RESPONSE_STATE,
  ALL_USERS,
  SELECTED_USERS,
  CURRENT_ABILITATIONS,
  ADDED_BR,
  ADDED_ENTITLEMENTS,
  BUSINESS_ROLES,
  DELETED_BR,
  DELETED_ENTITLEMENTS,
  ENTITLEMENTS,
  IS_SELF_SELECTED,
  MODIFIED_BR,
  MODIFIED_ENTITLEMENTS,
  PREV_ENTITLEMENTS,
  SELECTED_OFFICE,
  SELECTED_USER,
  STEP_THREE,
  TOTAL_ENTITLEMENTS,
  ENTITLEMENTS_BR_SELECTED,
  EXISTING_SAME_DB,
  DATE_ENTITLEMENTS,
  START_END_DATE,
  COMMENT,
  IS_COMMENT_COMPULSORY,
  SOD_CONFLICTS,
} = STATE_IDENTIFIER;

export default {
  [ALL_USERS]: [],
  [SELECTED_USERS]: [],
  [LOADER_IDENTIFIER]: false,
  [RESPONSE_STATE]: IResponseState.PENDING,
  [CURRENT_ABILITATIONS]: [],
  [SELECTED_OFFICE]: "",
  [IS_SELF_SELECTED]: false,
  [SELECTED_USER]: [],
  [ADDED_ENTITLEMENTS]: [],
  [ADDED_BR]: [],
  [DELETED_ENTITLEMENTS]: [],
  [DELETED_BR]: [],
  [MODIFIED_ENTITLEMENTS]: [],
  [EXISTING_SAME_DB]: [],
  [MODIFIED_BR]: [],
  [COMMENT]: "",
  [IS_COMMENT_COMPULSORY]: true,
  [SOD_CONFLICTS]: null,
  [STEP_THREE]: {
    [PREV_ENTITLEMENTS]: {
      [LIST_IDENTIFIER]: {
        [BUSINESS_ROLES_IDENTIFIER]: [],
        [ENTITLEMENTS_IDENTIFIER]: [],
      },
      [LOADER_IDENTIFIER]: false,
      [ENTITLEMENTS_BR_SELECTED]: {
        [LIST_IDENTIFIER]: [],
        [SHOW_TABLE_IDENTIFIER]: false,
      },
    },
    [ENTITLEMENTS]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
    [DATE_ENTITLEMENTS]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
      [START_END_DATE]: [],
    },
    [BUSINESS_ROLES]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
    [TOTAL_ENTITLEMENTS]: {
      [BUSINESS_ROLES_IDENTIFIER]: [],
      [ENTITLEMENTS_IDENTIFIER]: [],
    },
  },
};
